import {
  SET_REPORT_LIST,
  SET_REPORT_LOADING,
  SET_REPORT_HOME_LOADING,
  SET_REPORT_FILTERS,
  EMPTY_REPORT_LIST,
  SET_REPORT_HEADER_KEYS,
} from 'redux/actions/types';
const initialState = {
  reportList: [],
  filterList: [],
  reportId: null,
  loading: false,
  headerKeys: [],
  homeReportLoading: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_REPORT_HOME_LOADING: {
      return {
        ...state,
        homeReportLoading: payload
      }
    }
    case SET_REPORT_LIST:
      payload.data.map((item) => {
        if (item.provider === 'FOOD2') {
          item.provider = 'WEBSITEV2';
        }
      });
      return {
        ...state,
        reportList: payload.data,
      };
    case SET_REPORT_HEADER_KEYS:
      console.log(payload.data, 'payload.data');
      return {
        ...state,
        headerKeys: payload.data,
      };
    case EMPTY_REPORT_LIST:
      return {
        ...state,
        reportList: [],
      };
    case SET_REPORT_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case SET_REPORT_FILTERS:
      return {
        ...state,
        filterList: payload.data,
      };
    // case ADD_REPORT_FILTERS:
    //   return {
    //     ...state,
    //     filterList: [...state.filterList, payload.data],
    //   };
    default:
      return state;
  }
};
